if (!('focusgroup' in HTMLElement.prototype)) {
  import('@doeixd/scoped-focusgroup-polyfill')
}
